import app from "@/main";
import axiosDefault from "axios";
import Qs from "qs";
import router from "../router";

const axios = axiosDefault.create({
  baseURL: `${process.env.VUE_APP_API_ENDPOINT}/api/v1/admin_side`,
});

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axios.interceptors.request.use(
  (requestConfig) => {
    if (requestConfig.jwt) {
      const token = localStorage.getItem("token");
      if (token) {
        requestConfig.headers["Auth"] = token;
      }
    }

    requestConfig.paramsSerializer = (params) => {
      return Qs.stringify(params, {
        arrayFormat: "brackets",
        encode: false,
      });
    };

    return requestConfig;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (responseConfig) => {
    if (responseConfig.data) {
      const { alert, redirect_to } = responseConfig.data;

      if (alert) {
        app.$alertWindow(alert, "success");
      }

      if (redirect_to && router.currentRoute.path != redirect_to) {
        router.push(redirect_to);
      }
    }

    return responseConfig;
  },
  (error) => {
    if (!error.response) {
      // Network error / timeout / server unreachable
      app.$alertWindow("Network error. Please check your connection.", "error");
      return Promise.reject(error);
    }

    if (error.config?.silent) {
      return Promise.reject(error);
    }

    const { errors, redirect_to } = error.response.data;

    if (errors) {
      app.$alertWindow(errors.join("\n"), "error");
    } else if (!redirect_to) {
      const statusMessages = {
        400: "Invalid request. Please check your input.",
        401: "You are not authorized. Please log in.",
        403: "You don't have permission to perform this action.",
        404: "The requested resource was not found.",
        422: "Validation failed. Please check your input.",
        429: "Too many requests. Please slow down.",
        500: "Something went wrong on our end. Please try again later.",
        502: "Server is temporarily unavailable. Please try again.",
        503: "Service is currently unavailable. Please try again later.",
      };

      const message =
        statusMessages[error.response.status] ||
        "An unexpected error occurred. Please try again.";
      app.$alertWindow(message, "error");
    }

    if (redirect_to && router.currentRoute.path != redirect_to) {
      router.push(redirect_to);
    }

    return Promise.reject(error);
  }
);

export { axios };
